import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeProvider } from '../../../../actions/providers';
import Row from '../../../../components/Basic/Blocks/Row';
import Button from '../../../../components/Basic/Buttons/Button';
import H2 from '../../../../components/Basic/WrapsStyle/H/H2';
import { TYPE_BUTTONS } from '../../../../constans';

import ProviderInfoApi from '../../../../API/provider/providerInfo-api';
import PopUp from '../../../../components/Basic/Blocks/PopUp';
import CheckButton from '../../../../components/Basic/Buttons/Check';
import Input from '../../../../components/Basic/Inputs/Base';
import Text from '../../../../components/Basic/WrapsStyle/Text';
import styles from './styles.module.scss';

const EditProvider = ({ close = () => { }, provider = {} }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: provider.name,
    prefix: provider.prefix,
    course: provider.course,
  });

  const [valid, setValid] = useState({
    name: '',
  });

  const disabled_button = !data.name.length > 0;

  const validate = () => {
    if (!disabled_button) {
      return true;
    } else {
      setValid({
        name: data.name.length > 0 ? '' : 'Заполни поле ',
      });
      return false;
    }
  };

  const clickAdd = async () => {
    if (validate()) {
      await ProviderInfoApi.changeProvider({ data: { providerId: provider.id, data: { ...data, course: parseInt(data.course) } } })
        .then((r) =>
          dispatch(changeProvider(provider.id, r.provider)),
        );
      close();
    }
  };

  useEffect(() => {
    setValid({ name: '' });
  }, [data.name]);

  useEffect(() => {
    setData({ name: provider.name, prefix: provider.prefix, course: provider.course, is_stock: provider.is_stock });
  }, [provider]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Изменить поставщика</H2>
      <Input
        value={data.name}
        label="Имя"
        width="80%"
        error={valid.name}
        style={{ marginBottom: '5px' }}
        onChange={(v) => setData({ ...data, name: v })}
      />
      <Input value={data.prefix} label="Префикс" width="80%" onChange={(v) => setData({ ...data, prefix: v })} />
      <Input value={data.course} label="Курс" width="80%" onChange={(v) => setData({ ...data, course: v })} />

      <Row style={{ marginTop: '10px' }}>
        <CheckButton
          checked={data.is_stock}
          onSelect={(v) => setData({ ...data, is_stock: v })}
          style={{ marginRight: '15px' }}
        />
        <Text>Мелкий поставщик</Text>
      </Row>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={disabled_button}
          style={{ marginRight: '15px' }}
          onClick={disabled_button ? () => { } : clickAdd}
        >
          Изменить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default EditProvider;
